import { InlineWidget, useCalendlyEventListener } from 'react-calendly'
import CloseIcon from '@mui/icons-material/Close'
import { Modal } from 'settle-ui/components/Modal/Modal'
import { logEvent } from 'lib/tracking/segment'
import {
  CALENDLY_DEMO_DATE_AND_TIME_SELECTED,
  CALENDLY_DEMO_MODAL_OPEN,
  CALENDLY_DEMO_SCHEDULED,
} from './ScheduleDemoDialog.events'

interface ScheduleDemoDialogProps {
  isOpen: boolean
  url: string
  onClose(): void
}

export const ScheduleDemoDialog: React.FC<ScheduleDemoDialogProps> = ({ isOpen, onClose, url }) => {
  useCalendlyEventListener({
    onEventScheduled: () => {
      sessionStorage.setItem('is_demo_scheduled', 'true')
      logEvent(CALENDLY_DEMO_SCHEDULED)
    },
    onDateAndTimeSelected: () => {
      logEvent(CALENDLY_DEMO_DATE_AND_TIME_SELECTED)
    },
    onEventTypeViewed: () => {
      logEvent(CALENDLY_DEMO_MODAL_OPEN)
    },
  })

  return (
    <Modal
      open={isOpen}
      PaperProps={{
        sx: {
          overflow: 'hidden',
          height: '850px',
        },
      }}
      onClose={onClose}
    >
      <CloseIcon sx={{ position: 'absolute', left: 0 }} onClick={onClose} />
      <InlineWidget
        url={url}
        styles={{
          height: '100%',
        }}
      />
    </Modal>
  )
}
